import { useActionState, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Label from "../../components/label";
import Input from "../../components/input";
import { Button } from "../../components/button";
import {
  AtSymbolIcon,
  ExclamationCircleIcon,
  ArrowRightIcon,
  KeyIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import FormError from "../../components/form-error";
import Fonts from "../../core/fonts";
import { UserRole } from "../../enums";
import UsersService from "../../services/UserService";
import { verifyPhone } from "./actions/verifyPhone";
import Spinner from "../../components/spinner";
import VerificationCodeInput from "../../components/verification-code-input";

export default function VerifyPhonePage() {
  const navigate = useNavigate();
  const auth = useAuth();
  const api = new UsersService();
  const [searchParams] = useSearchParams();
  const verificationId = searchParams.get("verificationId") || "";
  const phone = searchParams.get("phone") || "";
  const rememberMe = searchParams.get("rememberMe") || "false";
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const [verificationCode, setVerificationCode] = useState("");
  const [state, formAction, isPending] = useActionState(verifyPhone, {
    success: false,
    message: null,
    defaultValues: {
      phone: phone,
      verificationId: verificationId,
      code: "",
      rememberMe: rememberMe === "true",
    },
    errors: {},
  });

  useEffect(() => {
    return () => auth.loaded(true);
  }, []);

  useEffect(() => {
    if (state?.success) {
      // delete state.data?.token;
      // if (state.data) auth.login(state.data);
      // load user profile
      //navigate("/admin");
      fetchProfile();
    }
  }, [state, callbackUrl]);

  useEffect(() => {
    if (auth.ready && auth.user) {
      if (callbackUrl == "/") {
        // navigate to admin
        if ([UserRole.ADMIN, UserRole.SUPERADMIN].indexOf(auth.user.role) > -1)
          navigate("/admin");
        else navigate("/client");
      } else navigate(callbackUrl);
    }
  }, [auth.ready, auth.user, callbackUrl]);

  const fetchProfile = async () => {
    try {
      const response = await api.getMyProfile();
      auth.login(response.data);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
    auth.loaded(true);
  };
  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // e.preventDefault();
    auth.loaded(false);
  };
  return (
    <div className="flex items-center justify-center flex-1">
      <form
        className="space-y-3 w-full max-w-md"
        action={formAction}
        onSubmit={handleOnSubmit}
      >
        <div className="flex-1 rounded-lg bg-gray-50 px-6 pb-4 pt-8">
          <h1 className={`${Fonts.lusitanaRegular} mb-3 text-2xl`}>
            Please verify your phone number.
          </h1>
          <div className="w-full text-center">
            <div className="mt-4">
              <Label                 
                htmlFor="code"
                className="text-center block mb-6 text-lg"
              >
                Enter verification code
              </Label>
              <VerificationCodeInput
                id="code"
                name="code"
                length={6}
                value={verificationCode}
                onChange={setVerificationCode}
                onComplete={(code) => {
                  // Auto-submit when code is complete
                  setTimeout(() => {
                    const form = document.querySelector('form');
                    if (form) {
                      form.requestSubmit();
                    }
                  }, 100);
                }}
                error={!!(state && state.errors?.code)}
                className="mb-4"
              />
              <FormError
                id="code-error"
                message={state && state.errors?.code}
              ></FormError>
            </div>
             <input type="hidden" name="verificationId" value={state && state.defaultValues?.verificationId} />
             <input type="hidden" name="phone" value={state && state.defaultValues?.phone} />
             <input type="hidden" name="rememberMe" value={state && state.defaultValues?.rememberMe?"on":"off"} />
          </div>
          <input type="hidden" name="callbackUrl" value={callbackUrl} />
          <Button className="mt-4 w-full" aria-disabled={isPending}>
            Verify {isPending? <div className="ml-auto"><Spinner visible size="small"  /></div> : <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />}
          </Button>
          <div className="flex h-8 items-end space-x-1">
            {state && !state.success && state.message && (
              <>
                <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                <p className="text-sm text-red-500">{state.message}</p>
              </>
            )}
          </div>
          <div className="mt-1 flex w-full items-center justify-around text-purple-500">
            
            <Link to={"/auth/login"}>
              <span>Login</span>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}
